import { useEffect, useState } from 'react';
import ResourcePlanningS from '../restapi/resourcePlanningS';
import { PlanningGroup } from '../../Types/ResourceT';

// eslint-disable-next-line import/prefer-default-export
export const usePlanningGroup = (groupId: string | null) => {
  const [loading, setLoading] = useState(false);
  const [planningGroup, setPlanningGroup] = useState<PlanningGroup | null>(null);

  useEffect(() => {
    if (groupId) {
      setLoading(true);
      ResourcePlanningS.getPlanningGroup(groupId)
        .then(setPlanningGroup)
        .finally(() => setLoading(false));
    }
  }, [groupId]);

  return { loading, planningGroup };
};
